import React from "react"
import styles from "./languageFooter.module.scss"
import globalStyles from "../services/globalStyles.module.scss"
import { setNewLanguage } from "../services/languageService";
const LanguageFooter = () => {

  const languages = [
    {value: "ENGLISH", code: "en"},
    {value: "ČESKY", code: "cs"},
    {value: "DANSK", code: "da"},
    {value: "DEUTSCH", code: "de"},
    {value: "ESPAÑOL", code: "es"},
    {value: "ΕΛΛΗΝΙΚΆ", code: "el"},
    {value: "FRANÇAIS", code: "fr"},
    {value: "ITALIANO", code: "it"},
    {value: 'עִבְרִית‎', code: "he"},
    {value: "MAGYAR", code: "hu"},
    {value: "BAHASA MELAYU", code: "ms"},
    {value: "NEDERLANDS", code: "nl"},
    {value: "NORSK", code: "no"},
    {value: "POLSZCZYZNA", code: "pl"},
    {value: "PORTUGUÊS", code: "pt"},
    {value: "РУССКИЙ ЯЗЫК", code: "ru"},
    {value: "SUOMI", code: "fi"},
    {value: "SVENSKA", code: "sv"},
    {value: "简体中文", code: "zh"},
  ];

  const changeLanguage = (code) => {
    if (typeof window !== 'undefined' && window.navigator && window.navigator.language && document && document.location) {
      setNewLanguage(code);
    }
  }

  return (
    <div className={[styles.container, globalStyles.contentContainer140, globalStyles.contentContainerMobile20].join(' ')}>
      <div className={styles.content}>
        {
          languages.map((val, index) => {
            return <span key={index} className={styles.language} onClick={() => { changeLanguage(val.code) }}>{val.value}</span>
          })
        }
      </div>
    </div>
  )
}

LanguageFooter.propTypes = {}

export default LanguageFooter
